import { Menu, MenuButton, MenuItem } from "@reach/menu-button";
import { MenuContainer, MyMenuList } from "./menu-option-style";
import "@reach/menu-button/styles.css";

interface Props {
   options: any;
   optionsFns: any;
   onClose: any;
   menuButton: any;
   disabled?: boolean;
   noMargin?: boolean;
}

export function MenuOptions({
   options,
   optionsFns,
   onClose,
   menuButton,
   disabled,
   noMargin,
}: Props) {
   function handleClick(index: number) {
      optionsFns[index]();
      onClose();
   }

   return (
      <MenuContainer noMargin={noMargin}>
         <Menu>
            <MenuButton disabled={disabled} className="menu-button">
               {menuButton}
            </MenuButton>
            <MyMenuList portal>
               {options.map((option: string, index: number) => (
                  <MenuItem
                     key={option}
                     className={`option ${option === "Delete" ? "delete-option" : ""}`}
                     onSelect={() => handleClick(index)}
                  >
                     {option}
                  </MenuItem>
               ))}
            </MyMenuList>
         </Menu>
      </MenuContainer>
   );
}
